import { ProductRuleList } from "Requests/ProductsRules";
import { ListItem as ListItemComponent } from "../ProductRulesList/styles";

type ListItemsProps = {
  item: ProductRuleList;
  handleItemClick: (item: ProductRuleList) => void;
};

export const ListItem = ({ item, handleItemClick }: ListItemsProps) => {
  return (
    <ListItemComponent
      key={String(item.product_id)}
      onClick={() => handleItemClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleItemClick(item);
        }
      }}
    >
      <div className="product-name">{item.product_name}</div>
      <div className="synonyms-preview">
        Sinônimos:
        {item.synonyms ? ` ${item.synonyms}` : "Sem sinônimos"}
      </div>
    </ListItemComponent>
  );
};
